<template>
  <div class="user-visits-list">
    <div
      v-for="(userVisit, index) in userVisits"
      :key="userVisit.id"
      class="user-visit-row"
    >
      <div class="user-details">
        <div> {{userVisit.user.firstName}} {{userVisit.user.lastName}}</div>
        <div> {{userVisit.user.phone}}</div>
        <div style="margin: 0 15px"> {{userVisit.user.email}}</div>
        <div style="margin: 0 15px" v-if="userVisit.leftAt">{{formatDateTime(userVisit.leftAt)}}</div>
        <div style="margin: 0 15px" v-else>present</div>
<!--        <div style="margin: 0 15px">-->
<!--          <a :href="userVisit.user.image" target="_blank">-->
<!--            <img :src="userVisit.user.image" style="width:150px">-->
<!--          </a>-->
<!--        </div>-->
        <user-visit-sector
          :sector="userVisit.sector"
          :disable-update="userVisit.leftAt? true : false"
          @updateUserSector="$e => updateUserSector($e, userVisit)"/>
      </div>
    </div>
  </div>
</template>

<script>
  import UserVisit from "./UserVisit";
  import UserVisitSector from "./UserVisitSector";

  export default {
    name: "UserVisitsList",
    components: {UserVisitSector, UserVisit},
    props: {
      userVisits: {
        type: Array,
        default: function () {
          return [];
        }
      }
    },

    methods: {
      formatDateTime(dateString) {
        let date  = new Date(dateString);
        return date.toLocaleString();
      },
      updateUserSector(sector, visit) {
        if (visit.leftAt) {
          this.$notify({
            title: 'User already left',
            duration: 10000,
            type: 'warn',
          })
        } else {
          this.$emit('updateUserSector', {visitId: visit.id, sector})

        }


      }
    }
  };
</script>

<style lang="scss">
  @import "UserVisitsList";
</style>
